import { Box, Button, Card, CardHeader, Checkbox, Divider, FormControlLabel, FormGroup, Grid, IconButton, Paper, Typography } from '@mui/material';
import { proctorResultApiKeyStore } from "../../../api/proctor-result-api-key-store";
import { useLoadData } from "../../../hooks/useLoadData";
import { ApiResponse } from "../../../models/api-response";
import { useEffect, useState } from 'react';
import { UserPermissionName } from '../../../models/user-permission-name';
import { GuardedComponent } from '../../../components/guarded-component';
import { Icons } from '../../../assets/icons';
import { useFileDownload } from '../../../components/file-download';
import { LoadingIndicator } from '../../../components/loading-indicator.component';

const styling = {
    root: { borderRadius: '10px' },
    textColor: { color: '$primary-color' },
    headingStyle: { color: '#0000b5', paddingBottom: '10px' },
    labelStyle: { color: '#0000b5', fontSize: '14px' },
    valueStyle: { color: '#000', fontWeight: '500', fontSize: '13px' },
};

interface UnitProctorResultComponrnt {
    unitData: any;
}

export const UnitProctorResultComponrnt = ({ unitData }: UnitProctorResultComponrnt) => {

    const [proctorResultData, setProctorResult] = useState<any>();

    const { data, isLoading, isFetching } = useLoadData<ApiResponse<any>>(
        proctorResultApiKeyStore.getUnitProctorResults(unitData?.unitID)
    );

    const { downloadFile, isLoading: isFileDownloadLoading } = useFileDownload();

    useEffect(() => {
        if (data?.data) {
            setProctorResult(data?.data[0]);
        }
    }, [data])

    const handleDownloadFile = async (data: any) => {
        const value = {
            proctorResultsID: Number(data?.proctorResultsID) || 0,
            fileName: data?.uploadedFileName,
            fileType: data?.fileType,
        };
        downloadFile({ additionalData: value });
    };

    return (
        <Card elevation={0}>
            <CardHeader
                className="subHead"
                title={
                    <div className="d-flex" style={{ justifyContent: 'space-between' }}>
                        <Typography variant="h3" color="textPrimary" style={styling.headingStyle}>
                            PROCTOR RESULT
                        </Typography>
                    </div>
                }
            />
            <Divider sx={{ borderBottomWidth: '2px' }} />
            <Paper elevation={0} style={{ padding: 20, borderRadius: '10px' }}>
                <Grid container>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                        <Typography className="d-flex flex-column mBm">
                            <label style={styling.labelStyle}>Proctor File Name</label>
                            <span style={styling.valueStyle}>{!proctorResultData?.proctorFileName ? '---' : `${proctorResultData?.proctorFileName}`}</span>
                        </Typography>
                    </Grid>{' '}
                    <Grid item xl={2.5} lg={2.5} sm={6} xs={6}>
                        <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                            <label style={styling.labelStyle}>Proctor Date</label>
                            <span style={styling.valueStyle}>{!proctorResultData?.proctorDate ? '---' : `${proctorResultData?.proctorDate}`}</span>
                        </Typography>{' '}
                    </Grid>
                    <Grid item xl={3.5} lg={3.5} sm={6} xs={6}>
                        <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                            <label style={styling.labelStyle}>Proctor File Name</label>
                            <span style={styling.valueStyle}>{!proctorResultData?.fileNumber ? '---' : `${proctorResultData?.fileNumber}`}</span>
                        </Typography>{' '}
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                        <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                            <label style={styling.labelStyle}>Dry Density</label>
                            <span style={styling.valueStyle}>{!proctorResultData?.dryDensity ? '---' : `${proctorResultData?.dryDensity}`}</span>
                        </Typography>
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                        <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                            <label style={styling.labelStyle}>Optimum Moisture Content</label>
                            <span style={styling.valueStyle}>{!proctorResultData?.optimumMoistureContent ? '---' : `${proctorResultData?.optimumMoistureContent}`}</span>
                        </Typography>
                    </Grid>
                    <Grid item xl={2.5} lg={2.5} sm={6} xs={6}>
                        <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                            <label style={styling.labelStyle}>Visual Soil Characteristics</label>
                            <span style={styling.valueStyle}>{!proctorResultData?.visualSoilCharacteristics ? '---' : `${proctorResultData?.visualSoilCharacteristics}`}</span>
                        </Typography>
                    </Grid>
                    <Grid item xl={3.5} lg={3.5} sm={6} xs={6}>
                        <LoadingIndicator isLoading={isFileDownloadLoading} />
                        <Typography className="d-flex flex-column mBm">
                            <label style={styling.labelStyle}>Uploaded File Name</label>
                            <span style={styling.valueStyle}>
                                {' '}
                                {!proctorResultData?.uploadedFileName ? '---' : proctorResultData?.uploadedFileName}
                                {!!proctorResultData?.uploadedFileName && (
                                    <GuardedComponent requiredPermissions={[UserPermissionName.DOWNLOAD_FILE]}>
                                        <span>
                                            <IconButton disabled={isFileDownloadLoading} aria-label="download" onClick={() => handleDownloadFile(proctorResultData)}>
                                                <img src={Icons.FileDownload} alt="Download" />
                                            </IconButton>
                                        </span>
                                    </GuardedComponent>
                                )}
                            </span>
                        </Typography>
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                        <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                            <label style={styling.labelStyle}>Updated On</label>
                            <span style={styling.valueStyle}>{!proctorResultData?.updatedOn ? '---' : `${proctorResultData?.updatedOn}`}</span>
                        </Typography>
                    </Grid>
                </Grid>
            </Paper>
        </Card>
    );
}